import { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import AsideNavbar from 'src/components/AsideNavbar';
import PortalNavBar from 'src/components/PortalNavbar';
import SemFoto from 'src/img/semFoto.png';
import Switch from 'react-switch';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useUserContext } from 'src/contexts/UserContext';
import FooterSuporte from 'src/components/FooterSuporte';
import {
  switchVariantStatus,
  formatImage,
  formatPrice,
} from 'src/services/utils/index';
import ModalComponent from 'src/components/Modal/ModalComponent';
import useModal from 'src/services/hooks/useModal';
import {
  MINIMAL_SUGGESTED_PRICE_ERROR_MESSAGE,
  validateMinimalSuggestedPrice,
  calculatePercentageDiscountToTheProduct,
  calculateTotalPriceOfProductBox,
  uploadProductData,
  initialSaleFormat,
  calculateDiscountPrice,
  isProductBlockedToUpdate,
} from './utils';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import { ProductsService } from 'src/services/Products';
import { updateProduct } from 'src/services/Products/utils/product-handler';
import './style.css';
import { SalesFormat } from './types';
import { initialState } from './utils/productPageInitialState';
import StockOut from './containers/StockOut';
import { VariantsTable } from './containers/VariantsTable/VariantsTable';
import ContactToModify from '../Products/components/Contact/ContactToModify';
import { Description } from './components/Description';
import { DeliveryPlace } from './components/DeliveryPlace';
import { errorMessageFormEditProduct } from './utils/errorMessages';

const IS_PRODUCT_DISCOUNT_ENABLED = false;

export function EditProduct() {
  const [produto, setProduto] = useState();
  const [urlShopify, setUrlShopify] = useState();
  const { id } = useParams();
  const { token, showToast, userData } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [productState, setChanges] = useState(initialState);
  const [openModalComp, setOpenModal, variant, setVariant] = useModal();
  const currentProduct = useRef();
  const focus = useRef();

  const vendorIsBlockedToEditProduct = userData && userData.supplier_blocked;

  const blockedToUpdateInfo = useMemo(
    () =>
      isProductBlockedToUpdate(produto?.tags) || vendorIsBlockedToEditProduct,
    [produto, vendorIsBlockedToEditProduct],
  );
  const valueThatRemoveTheIncreaseAmountTag = '1';

  const [salesFormat, setSalesFormat] = useState(SalesFormat.UNIDADE);

  useEffect(() => {
    if (!focus.current) {
      setSalesFormat(
        initialSaleFormat(
          productState.increase_amount,
          valueThatRemoveTheIncreaseAmountTag,
        ),
      );
    }
  }, [productState.increase_amount]);

  const history = useHistory();

  function putChange(name, value) {
    setChanges(prev => ({ ...prev, [name]: value }));
  }

  const handleChangeSalesFormat = event => {
    setSalesFormat(event.target.value);
  };

  function validateMax(e) {
    if (e.target.value > 100) {
      document.querySelector('.discount-input input').value = 100;
    }
    if (e.target.value === '') {
      document.querySelector('.discount-input input').value = 0;
    }
    if (e.target.value > 0) {
      if (e.target.value.toString()[0] === '0') {
        const newValue = e.target.value.toString().substring(1, 10);
        document.querySelector('.discount-input input').value =
          parseFloat(newValue);
      }
    }
  }

  const getProductInfo = useCallback(async () => {
    try {
      const { data: product } = await ProductsService.getProductById({ id });
      setProduto(product);
      setChanges(uploadProductData(product));
      currentProduct.current = uploadProductData(product);
      const url = `https://inventa.shop/products/${product.handle}`;
      setUrlShopify(url);
    } catch (error) {
      showToast('Ocorreu um erro ao carregar o produto', 'error');
    }
  }, [id, showToast]);

  useEffect(() => {
    getProductInfo();
  }, [getProductInfo]);

  const openModalIfThereWereChangesAndNoErrors = () => {
    const statusAlert = 'error';

    const isProductModified =
      JSON.stringify(currentProduct.current) !== JSON.stringify(productState);

    if (isProductModified) {
      setOpenModal(true);
      return;
    }

    window.scroll(0, 0);
    showToast(errorMessageFormEditProduct, statusAlert);
  };

  const shouldRenderComponent = Boolean(produto) && productState?.variants;
  const vendorHasManagedStock = userData && userData.managed_stock;
  const containsProductOptions = produto?.variants.length > 1;

  return (
    <div id="wrapper">
      <AsideNavbar />
      <div id="page-wrapper">
        <PortalNavBar />
        <div className="container px-2 py-4">
          {/* MODALS */}
          {openModalComp && (
            <ModalComponent
              title="Modificar produto"
              closeModal={() => setOpenModal(false)}
            >
              <p className="card-text pb-3">
                O produto vai mudar suas propriedades.
                <br /> Deseja modificar o produto?
              </p>

              <button
                className="btn btn-confirm"
                data-testid="btn-confirm-update"
                disabled={vendorIsBlockedToEditProduct}
                onClick={async () => {
                  const errorMsg = 'Opa, alguma coisa foi mal';
                  let error = false;

                  setLoading('editProduct');
                  if (
                    productState.increase_amount <= '0' ||
                    productState.increase_amount === ''
                  ) {
                    error = true;
                    showToast(
                      'O múltiplo de venda não pode ser menor ou igual a 0 ou vazio',
                      'error',
                    );
                  }

                  const suggestedPrice =
                    produto?.suggested_retail_price === undefined
                      ? productState.suggested_retail_price
                      : productState.suggested_retail_price === ''
                      ? 0
                      : productState.suggested_retail_price ||
                        produto?.suggested_retail_price;
                  const fullPrice =
                    productState.full_price || produto?.full_price;
                  if (
                    !validateMinimalSuggestedPrice(suggestedPrice, fullPrice)
                  ) {
                    error = true;
                    showToast(MINIMAL_SUGGESTED_PRICE_ERROR_MESSAGE, 'error');
                  }

                  if (!error && !vendorIsBlockedToEditProduct) {
                    const productUpdatedSuccessfully = await updateProduct(
                      id,
                      productState,
                      currentProduct,
                      salesFormat,
                    );

                    if (!productUpdatedSuccessfully) {
                      error = true;
                      showToast(errorMsg, 'error');
                    }
                  }

                  window.scroll(0, 0);
                  setLoading(false);
                  setOpenModal(false);
                  if (!error) {
                    showToast(
                      'Enviado com sucesso! Aguarde alguns segundos para atualização do produto.',
                      'success',
                    );
                    history.push('/product');
                  }
                }}
              >
                {loading === 'editProduct' ? (
                  <div className="spinner-border " role="status" />
                ) : (
                  'Modificar produto'
                )}
              </button>
            </ModalComponent>
          )}
          {variant && (
            <ModalComponent
              title={
                variant.action === 'activate'
                  ? 'Ativação de Variante'
                  : 'Desativação de Variante'
              }
              closeModal={() => setVariant(false)}
            >
              {variant.action === 'activate' ? (
                <p className="card-text pb-3">
                  O produto ficará disponível para todos os lojistas da Inventa
                  realizarem pedidos.
                  <br /> Deseja ativar o produto?
                </p>
              ) : (
                <p className="card-text pb-3">
                  O produto será desativado temporariamente do seu catálogo
                  virtual na Inventa, impedindo os lojistas de comprarem este
                  item até que o mesmo volte ao estoque e seja reativado por
                  você.
                  <br /> Deseja desativar o produto?
                </p>
              )}
              <button
                className="btn btn-confirm"
                onClick={() => {
                  const { productID, variantID, action, token } = variant;
                  switchVariantStatus(productID, variantID, action, token);
                  const newProduct = produto;
                  newProduct.variants.forEach(e => {
                    if (e.id === variantID) {
                      e.inventory_policy =
                        variant.action === 'activate' ? 'continue' : 'deny';
                    }
                  });

                  setProduto(newProduct);
                  setVariant(false);
                }}
              >
                {variant.action === 'activate'
                  ? 'Ativar Variante'
                  : 'Desativar Variante'}
              </button>
            </ModalComponent>
          )}
          {/*
          {/*TITULO */}
          <div className="row mb-2">
            <div className="col-12">
              <Link to="/product" className="change-link">
                <span>
                  <i className="fas fa-arrow-left" aria-hidden="true" /> voltar
                </span>
              </Link>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-8">
              <h1 className="fs-2 fw-light">
                {produto && produto.name ? produto.name : ''}
              </h1>
            </div>
            <div className="col-4">
              {/* // TODO: abstract product statuses to enum: https://github.com/rauschma/enumify */}
              {Boolean(produto?.status === 'active' && urlShopify) && (
                <a
                  className="text-secondary text-decoration-none "
                  target="_blank"
                  href={urlShopify}
                  rel="noreferrer"
                >
                  <div className="ms-2 position-relative">
                    <i
                      className="fas fa-external-link-alt position-absolute fs-5 ps-2 ms-1"
                      aria-hidden="true"
                    />
                    <span
                      className="d-block pt-4 mt-2"
                      style={{ fontSize: '10px' }}
                    >
                      visualizar
                    </span>
                  </div>
                </a>
              )}
            </div>
          </div>
          {/* IMAGEN */}
          <div className="row mb-4">
            <div className="col-12">
              <img
                src={
                  produto && produto.image
                    ? formatImage(produto.image.src, '_240x240')
                    : SemFoto
                }
                alt={produto?.name || 'Foto do produto'}
              />
            </div>
          </div>
          {/* SKU */}
          <div className="row">
            <div className="col-12">
              <p className="fw-bold text-uppercase mb-0">SKU</p>
              <p className="text-secondary">
                {produto && produto.variants[0].sku
                  ? produto.variants[0].sku.split('|')[0]
                  : ''}
              </p>
            </div>
          </div>
          <Description
            updateValue={putChange}
            value={productState.body_html}
            disabled={blockedToUpdateInfo}
          />
          <DeliveryPlace tags={produto?.tags} />
          <FormControl component="fieldset" disabled={blockedToUpdateInfo}>
            <p className="fw-bold mb-0 mt-5">Formato de venda</p>
            <RadioGroup
              className="mt-3"
              aria-label="gender"
              name="salesFormat"
              data-testid="radio-salesFormat"
              value={salesFormat || ''}
              onChange={handleChangeSalesFormat}
            >
              <FormControlLabel
                value={SalesFormat.UNIDADE}
                control={<Radio />}
                label={SalesFormat.UNIDADE}
              />
              <FormControlLabel
                value={SalesFormat.CAIXA}
                control={<Radio />}
                label={SalesFormat.CAIXA}
              />
            </RadioGroup>
          </FormControl>
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-4">
              <p className="fw-bold mb-0">Pedido mínimo</p>
              {salesFormat === SalesFormat.CAIXA && (
                <p className="text-secondary mb-0">Em número de caixas</p>
              )}
            </div>
            <div className="col-12 col-md-4">
              <TextField
                className="mt-3 w-100"
                type="number"
                value={productState.minimum_purchase_amount || ''}
                variant="outlined"
                name="minimum_purchase_amount"
                data-testid="inpt-minimum_purchase_amount"
                onChange={e =>
                  putChange('minimum_purchase_amount', e.target.value)
                }
                onKeyDown={e => {
                  if (!e.key.match(/[0-9]/g) && e.key !== 'Backspace') {
                    e.preventDefault();
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: {
                    min: 0,
                    step: 1,
                    pattern: '[0-9]',
                    'data-testid': 'inpt-minimum-purchase-amount',
                  },
                }}
                disabled={blockedToUpdateInfo}
              />
            </div>
          </div>
          {salesFormat === SalesFormat.CAIXA && (
            <div className="row d-flex align-items-center">
              <div className="col-12 col-md-4">
                <p className="fw-bold mb-0">Quantidade de itens por caixa</p>
              </div>
              <div className="col-12 col-md-4">
                <TextField
                  className="mt-3 w-100"
                  type="number"
                  onFocus={() => {
                    focus.current = true;
                  }}
                  onBlur={() => {
                    focus.current = false;
                  }}
                  value={productState?.increase_amount || ''}
                  variant="outlined"
                  onChange={event => {
                    putChange('increase_amount', event.target.value);
                  }}
                  InputProps={{
                    inputProps: {
                      min: 1,
                      'data-testid': 'inpt-increase-amount',
                    },
                  }}
                  disabled={blockedToUpdateInfo}
                />
              </div>
            </div>
          )}
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-4">
              <p className="fw-bold mb-0">Preço da unidade (R$)</p>
            </div>
            <div className="col-12 col-md-4">
              <TextField
                className="mt-3 w-100"
                type="number"
                placeholder="R$"
                value={productState.full_price || ''}
                variant="outlined"
                onChange={e => putChange('full_price', e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: { min: 0, 'data-testid': 'inpt-full-price' },
                }}
                disabled={blockedToUpdateInfo}
              />
            </div>
            {salesFormat === SalesFormat.CAIXA &&
              productState?.increase_amount &&
              productState.increase_amount > 0 &&
              productState.full_price && (
                <div className="col-12 col-md-2 mt-3">
                  <p className="fw-bold mb-0">
                    Preço por caixa:
                    <br />
                    <span className="discount-amount">
                      {formatPrice(
                        calculateTotalPriceOfProductBox(produto, productState),
                      )}
                    </span>
                  </p>
                </div>
              )}
          </div>

          {IS_PRODUCT_DISCOUNT_ENABLED && (
            <>
              <div className="row d-flex align-items-center">
                <div className="col-12 col-md-4">
                  <p className="fw-bold mb-0">Desconto no produto (%)</p>
                </div>
                <div className="col-12 col-md-4">
                  <TextField
                    className="mt-3 w-100 discount-input"
                    InputProps={{
                      inputProps: {
                        'data-testid': 'inpt-discount-percentage',
                      },
                    }}
                    type="number"
                    placeholder="%"
                    variant="outlined"
                    onChange={e => {
                      validateMax(e);
                      putChange('discount_percentage', e.target.value);
                    }}
                    value={productState.discount_percentage || ''}
                    helperText="Procentagem de desconto no preço final do produto"
                    disabled={blockedToUpdateInfo}
                  />
                </div>
                {(produto &&
                  produto.discount_percentage &&
                  parseFloat(produto.discount_percentage)) ||
                (productState &&
                  productState.discount_percentage &&
                  parseFloat(productState.discount_percentage)) ? (
                  <div className="col-12 col-md-2 ">
                    <p className="fw-bold">
                      Desconto Aplicado:
                      <span className="discount-amount">
                        <br />
                        {formatPrice(
                          calculatePercentageDiscountToTheProduct(
                            produto,
                            productState,
                          ),
                        )}
                      </span>
                    </p>
                  </div>
                ) : null}
              </div>

              <div className="row d-flex align-items-center">
                <div className="col-12 col-md-4">
                  <p className="fw-bold mb-0">
                    Preço do produto com desconto (R$)
                  </p>
                </div>
                <div className="col-12 col-md-4">
                  <TextField
                    className="mt-3 w-100"
                    type="number"
                    placeholder="R$"
                    variant="outlined"
                    disabled
                    value={
                      calculateDiscountPrice(
                        productState?.full_price,
                        productState?.discount_percentage,
                      ) || ''
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: {
                        min: 0,
                        'data-testid': 'inpt-discount_percentage',
                      },
                    }}
                  />
                </div>
              </div>
            </>
          )}

          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-4">
              <p className="fw-bold mb-0">Preço de revenda sugerido (R$)</p>
              {salesFormat === SalesFormat.CAIXA && (
                <p className="text-secondary mb-0">Em valor unitário</p>
              )}
            </div>
            <div className="col-12 col-md-4">
              <TextField
                className="mt-3 w-100"
                type="number"
                placeholder="R$"
                variant="outlined"
                value={productState.suggested_retail_price || ''}
                onChange={e =>
                  putChange('suggested_retail_price', e.target.value)
                }
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: {
                    min: 0,
                    'data-testid': 'inpt-suggested-retail-price',
                  },
                }}
                disabled={blockedToUpdateInfo}
              />
            </div>
          </div>
          <div className="row d-flex align-items-center my-3">
            <div className="col-4">
              <p className="fw-bold mb-0">Produto publicado</p>
            </div>
            <div className="col-4">
              <Switch
                width={70}
                className="mt-2 mt-md-4"
                data-testid="switch-available"
                onColor="#222222"
                offColor="#F2F2F2"
                onHandleColor="#222222"
                offHandleColor="#222222"
                disabled={vendorIsBlockedToEditProduct}
                checked={productState?.status}
                onChange={checked => putChange('status', checked)}
                uncheckedIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      fontSize: 15,
                      color: '#666666',
                      paddingRight: 2,
                      paddingBottom: 3,
                    }}
                  >
                    não
                  </div>
                }
                checkedIcon={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                      fontSize: 15,
                      color: '#F2F2F2',

                      paddingRight: 2,
                      paddingBottom: 3,
                    }}
                  >
                    sim
                  </div>
                }
              />
            </div>
          </div>
          {shouldRenderComponent && !vendorHasManagedStock && (
            <StockOut productState={productState} onChange={putChange} />
          )}
          <ContactToModify />
          {/* BUTTONS */}
          <div className="row mb-4">
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <button
                className="input-add w-100"
                type="button"
                name="Modificar produto"
                data-testid="btn-modify-product"
                disabled={vendorIsBlockedToEditProduct}
                style={
                  // sorry for this :( couldn't find which css file to put it
                  vendorIsBlockedToEditProduct
                    ? {
                        cursor: 'not-allowed',
                        backgroundColor: '#808080',
                      }
                    : {}
                }
                onClick={openModalIfThereWereChangesAndNoErrors}
              >
                Modificar produto
              </button>
            </div>
          </div>
          {shouldRenderComponent && containsProductOptions && (
            <VariantsTable
              product={produto}
              setVariant={setVariant}
              token={token}
              vendorHasManagedStock={vendorHasManagedStock}
            />
          )}
        </div>
        <FooterSuporte />
      </div>
    </div>
  );
}
